<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { type MenuItem } from "../../lib/helpers/steps/menuItems";
  import Typography from "../Typography.svelte";
  import VariationPills from "./VariationPills.svelte";

  const dispatch = createEventDispatcher();

  export let item: MenuItem;
  export let active = false;
  export let unavailable: boolean = false;
  export let selectedVariation: string | undefined = undefined;
  export let useThickActiveBorder: boolean = false;
</script>

<button
  class="menu-item-card mobile flex flex-col p-3 items-start justify-start h-full text-left w-full rounded-2xl"
  class:unavailable
  class:active
  class:use-thick-active-border={useThickActiveBorder}
  aria-label={item.visible_name}
  on:click={() => !unavailable && dispatch("click")}>
  <img src={item.image} alt={item.visible_name} class="aspect-[248/172] w-full object-cover rounded-xl" />
  <div class="flex flex-col h-full mt-3">
    <Typography desktop={TypographyType.Headline3} mobile={TypographyType.Headline3}>
      {item.visible_name}
    </Typography>
    <div class="description flex-grow mt-1">
      <Typography mobile={TypographyType.Body2Medium} desktop={TypographyType.Body1Medium}>
        {item.description ?? ""}
      </Typography>
    </div>
    <VariationPills item={item} selectedVariation={selectedVariation} addMarginTop />
  </div>
</button>

<style>
  .menu-item-card:hover,
  .menu-item-card.active {
    border: 1px solid var(--color-grayscale-40);
  }

  .menu-item-card.active.use-thick-active-border {
    border: 4px solid var(--color-blue-50);
    padding: calc(0.75rem - 3px);
  }

  .menu-item-card .description {
    color: var(--color-grayscale-90);
  }

  @media (min-width: 1024px) {
    .menu-item-card {
      width: 17rem;
    }
  }
</style>
